//
//
//
//

export default {
  name: 'inline-desc'
}



// WEBPACK FOOTER //
// ./~/vux/src/components/inline-desc/index.vue